import { call, put, takeLatest } from 'redux-saga/effects';
import { SWITCH_TO_ANOTHER_GATEWAY_REQUEST, VALIDATE_SWITCH_GATEWAY_ASSET_REQUEST, GET_GATEWAY_ASSETS_LIST_REQUEST } from './constants';
import { GatewayManagementApi } from 'api';
import { apiCallStatus, NOTIFICATION_TYPES } from 'helpers/constants';
import { translate } from 'helpers/translateHelper';
import { notify } from 'sharedComponents/GeneralNotification';
import { actionTypes } from '../../../constants';
import { getAssetSwitchToAnotherGatewayAction, getAssetSwitchValidationGatewayAction, getGatewayAssetsListAction } from './actions';
function* switchToAnotherGatewaySaga(action) {
    yield put(getAssetSwitchToAnotherGatewayAction(apiCallStatus.LOADING));
    try {
        const response = yield call(GatewayManagementApi.switchAssetToAnotherGateway, action.sourceAssetId, action.targetGatewayId, action.targetAssetId, action.isSwitchEgwToAnotherGateway);
        if (response?.success) {
            yield put(getAssetSwitchToAnotherGatewayAction(apiCallStatus.SUCCESS));
            notify(translate('ABB.Powertrain.Frontend.AssetSwitchedSuccessMessage'), NOTIFICATION_TYPES.SUCCESS);
        } else if (response?.error) {
            notify(response?.error?.message, NOTIFICATION_TYPES.ERROR, true);
        }
        yield put({
            type: actionTypes.GET_GATEWAY_CONNECTED_ASSETS,
            payload: { gatewayID: action.gatewayId }
        });
        if (typeof action.onResetAssetInfo === 'function') {
            yield call(action.onResetAssetInfo);
        }
    } catch (error) {
        yield put(getAssetSwitchToAnotherGatewayAction(apiCallStatus.ERROR, [], error));
    }
}
function* getAssetsForGateway(action) {
    yield put(getGatewayAssetsListAction(apiCallStatus.LOADING));
    try {
        const response = yield call(GatewayManagementApi.getGatewayAssetsList, action.gatewaySerialNumber);
        yield put(getGatewayAssetsListAction(apiCallStatus.SUCCESS, response));
    } catch (error) {
        yield put(getGatewayAssetsListAction(apiCallStatus.ERROR, [], error));
    }
}
function* validateSwitchGatewayAssetSaga(action) {
    yield put(getAssetSwitchValidationGatewayAction(apiCallStatus.LOADING));
    try {
        const result = yield call(GatewayManagementApi.validateSwitchGatewayAsset, action.sourceAssetId, action.targetGatewayId, action.targetAssetId, action.isSwitchEgwToAnotherGateway);
        yield put(getAssetSwitchValidationGatewayAction(apiCallStatus.SUCCESS, result));
    } catch (error) {
        yield put(getAssetSwitchValidationGatewayAction(apiCallStatus.ERROR, [], error));
    }
}

export function* ValidateSwitchAssetGatewayWatchers() {
    yield takeLatest(VALIDATE_SWITCH_GATEWAY_ASSET_REQUEST, validateSwitchGatewayAssetSaga);
}
export function* GetAssetsForGatewayWatchers() {
    yield takeLatest(GET_GATEWAY_ASSETS_LIST_REQUEST, getAssetsForGateway);
}

export function* SwitchToAnotherGatewayWatchers() {
    yield takeLatest(SWITCH_TO_ANOTHER_GATEWAY_REQUEST, switchToAnotherGatewaySaga);
}
